<template>
  <md-dialog
    :md-active.sync="show"
    :md-close-on-esc="false"
    class="warning-dialog"
    @md-clicked-outside="closeDialog"
    @keyup.esc="closeDialog"
  >
    <md-dialog-title>
      {{ title || "Delete" }}
    </md-dialog-title>
    <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <div class="md-subheading warning-text">
        {{ message }}
      </div>
      <div dir="rtl">
        <md-button class="md-primary" @click="doDelete">{{ approveButton || "Delete" }}</md-button>
        <md-button @click="closeDialog">{{ closeButton || "Close" }}</md-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
export default {
  name: "DeleteDialog",
  props: ["show", "title", "message", "requestBody", "deleteApiName", "approveButton", "closeButton"],
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    doDelete: async function () {
      const response = await this.$api[this.deleteApiName]({
        params: this.requestBody,
      });
      if (response.status === 200) {
        this.$notify({
          message: "Deleted successfully.",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        this.$emit("deleted");
      } else {
        this.$notify({
          message: "Error occurred on deleting configuration.",
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "error",
        });
        this.closeDialog();
      }
    },
  },
};
</script>

<style scoped></style>

<!-- TODO: This dialog should use AreYouSure later. -->
